import { motion } from "framer-motion";
import SectionHeading from "@/components/SectionHeading";

const RESULTS = [
  {
    src: "/resultados/aluna-1.webp",
    alt: "Cartaz da FW Team Fitness com o comparativo de antes e depois de uma aluna: 'Resultado que não se mede só na balança. Definição, medidas e confiança.', com fotos rotuladas 'Antes' e 'Agora'.",
  },
  {
    src: "/resultados/aluna-2.webp",
    alt: "Cartaz da FW Team Fitness com o comparativo de antes e depois de uma aluna: '16,6 kg a menos. Uma virada real.', com fotos rotuladas 'Antes' e '7 meses depois'.",
  },
  {
    src: "/resultados/aluna-3.webp",
    alt: "Cartaz da FW Team Fitness com o comparativo de antes e depois de uma aluna: '6 kg a menos. Autoestima a mais.', com fotos de maio (85 kg) e julho (79 kg).",
  },
];

export default function ResultsSection() {
  return (
    <section id="resultados" className="relative scroll-mt-20 py-24 sm:py-28" data-testid="results-section">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Resultados"
          title="Movimento gera mudança"
          sub="Histórias reais de alunas que transformaram sua rotina com treino e acompanhamento."
          testId="results-heading"
        />

        <div className="mx-auto mt-12 grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="results-grid">
          {RESULTS.map((result, i) => (
            <motion.figure
              key={result.src}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, delay: i * 0.09, ease: [0.22, 1, 0.36, 1] }}
              className="relative h-full overflow-hidden rounded-2xl border border-white/10 bg-[#0d121c]/70 shadow-[0_4px_24px_rgba(0,0,0,0.5)] transition-colors duration-300 hover:border-brand-teal/50"
              data-testid={`result-card-${i + 1}`}
            >
              <img
                src={result.src}
                alt={result.alt}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-contain"
              />
            </motion.figure>
          ))}
        </div>

        <p
          className="mt-6 text-center text-xs text-slate-500"
          data-testid="results-disclaimer"
        >
          Resultados individuais. A evolução varia conforme as características e a rotina
          de cada pessoa.
        </p>
      </div>
    </section>
  );
}